import type { ReactNode } from 'react';

export const symbol_audio_video_receiver: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-340h680v-360H140v360Zm50 140q-12 0-21-9t-9-21v-50h-20q-24 0-42-18t-18-42v-360q0-24 18-42t42-18h680q24 0 42 18t18 42v360q0 24-18 42t-42 18h-20v50q0 12-8.62 21-8.63 9-21.38 9-12 0-21-9t-9-21v-50H220v50q0 12-8.62 21-8.63 9-21.38 9Zm-50-140v-360 360Zm596.5-123.5Q760-487 760-520t-23.5-56.5Q713-600 680-600t-56.5 23.5Q600-553 600-520t23.5 56.5Q647-440 680-440t56.5-23.5ZM270-440h240q12.75 0 21.38-8.63Q540-457.25 540-470v-100q0-12.75-8.62-21.38Q522.75-600 510-600H270q-12.75 0-21.37 8.62Q240-582.75 240-570v100q0 12.75 8.63 21.37Q257.25-440 270-440Z"
		/>
	</svg>
);
